import { tenderDateTimeFormat, useCountdown } from '@fv/client-core'
import { fvDate } from '@fv/dates'

type Props = {
  expiresAt: Date | string | null
}

export const TenderExpiration = ({ expiresAt }: Props) => {
  const { formattedLong, isExpired } = useCountdown(expiresAt)

  if (!expiresAt) return null
  if (isExpired) return <span className="mr-1">Tender expired</span>

  const countdownParts = formattedLong?.split(/\s+/) ?? []

  return (
    <>
      Tender expires on {fvDate(expiresAt).format(tenderDateTimeFormat)}
      <span className="mx-1 inline-flex items-center gap-1 tabular-nums font-medium">
        (
        {countdownParts.map((part, index) => (
          <span
            key={`${part}-${index}`}
            className="underline decoration-1 underline-offset-2"
          >
            {part}
          </span>
        ))}
        )
      </span>
      left
    </>
  )
}
